module.exports = __webpack_public_path__ + "static/Raleway-Light-606d4bb9477e0189edcf94e44e8e1ef3.woff2";